<template>
  <div class="app-container">
    <!-- 缩放容器 -->
    <div class="scale-wrapper">
      <HeaderComponent v-if="showHeaderAndFooter" />
      <a-config-provider :locale="zhCN">
        <router-view class="router-content" />
      </a-config-provider>
      <FooterComponent v-if="showHeaderAndFooter" class="router-content"/>
    </div>
  </div>
</template>

<script>
import HeaderComponent from './components/Header.vue';
import FooterComponent from './components/Footer.vue';
import zhCN from 'ant-design-vue/es/locale/zh_CN';

export default {
  name: 'App',
  components: {
    HeaderComponent,
    FooterComponent
  },
  data() {
    return {
      zhCN
    };
  },
  computed: {
    showHeaderAndFooter() {
      const hiddenRoutes = [
        'login', 
        'answerQuestions', 
        'complete', 
        'wrongAnswer', 
        'register', 
        'web3D'
      ];
      return this.$route.name && !hiddenRoutes.includes(this.$route.name);
    }
  }
};
</script>

<style>
html, body, #app {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
}

body {
  font-family: 'AlibabaPuHuiTi', Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2b2b2b;
  background-color: #f0f2f5;
}

.app-container {
  display: flex;
  height: 100vh;
  width: 100vw;
  overflow-x: hidden;
  background-color: #f0f2f5;
}

.scale-wrapper {
  width: 100%;
  min-height: 100%;
  background-color: #fff;
  position: relative;
}

/* 登录页面样式 */
.login-container {
  display: flex;
  height: 100%;
  width: 100%;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.login-container .login-image {
  width: 55%;
}

.login-container .login-form-container {
  width: 45%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
  box-sizing: border-box;
}

.login-container .login-form {
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 420px;
  padding: 40px 30px;
  background: rgba(255, 255, 255, 0.5);
  backdrop-filter: blur(28px);
  border-radius: 39px;
  box-shadow: 0px 10px 34px 0px rgba(9, 76, 150, 0.16);
  border: 1px solid rgba(255, 255, 255, 0.5);
  box-sizing: border-box;
}

/* 为路由内容添加全局样式控制 */
.router-content {
  width: 100%;
  max-width: 100vw;
  overflow-x: hidden;
}

/* 控制图片自适应 */
.router-content img {
  max-width: 100%;
  height: auto;
  display: block;
}

/* 为1920px设计的大图添加特殊处理 */
.router-content .full-width-image,
.router-content .banner-image {
  width: 100%;
  max-width: none;
  height: auto;
}

/* 响应式图片容器 */
.image-container {
  width: 100%;
  overflow: hidden;
}

.image-container img {
  width: 100%;
  height: auto;
  display: block;
}

/* 对于超宽图片的处理 */
.wide-image-wrapper {
  width: 100vw;
  overflow: hidden;
  position: relative;
  left: 50%;
  right: 50%;
  margin-left: -50vw;
  margin-right: -50vw;
}

.wide-image-wrapper img {
  width: 100%;
  height: auto;
  display: block;
}

/* 媒体查询适配不同屏幕 */
@media screen and (max-width: 768px) {
  .router-content img {
    max-width: 100%;
    height: auto;
  }
  
  .router-content .full-width-image {
    width: 100%;
  }
}

@media screen and (max-width: 480px) {
  .router-content img {
    max-width: 100%;
  }
}
</style>